import * as S from './styles';

type BackButtonProps = {
  children: React.ReactNode;
};

export const BackButton = ({ children }: BackButtonProps) => {
  return <S.Wrapper>{children}</S.Wrapper>;
};
